import { useResourceContext } from "@/layouts/ResourceContext";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { AddonDetailTabs, AddonVersionActions } from "@/resources-def/addons-comp";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react"
import { Table, Tabs } from "antd";
import { List, useTable } from "@refinedev/antd";
import { TopBreadcrumb } from "@/layouts/TopBreadcrumb";
import { useSearchParams } from "react-router-dom";

export const ShowAddonPage = () => {
  const { t } = useTranslation();
  const RESOURCE = 'addon';
  const [searchParams] = useSearchParams();  
  const type = searchParams.get("type");
    
  const columns = type == "module" ? [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Version", dataIndex: "version", key: "version" },
    { title: "Image Version", dataIndex: "aiops_image_version", key: "aiops_image_version" },
    { title: "Supported Platforms", dataIndex: "platforms", key: "platforms" },
    { title: "Module", dataIndex: "aiops_module_name", key: "aiops_module_name" },
    { title: "DC", dataIndex: "deployment_configs", key: "deployment_configs"}
  ] : type === "helm" ? [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Version", dataIndex: "version", key: "version" },
    { title: "Helm Name", dataIndex: "helm_repos_name", key: "helm_repos_name" },
    { title: "Docker Image Name", dataIndex: "image_repos_name", key: "image_repos_name" }
  ] : [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Version", dataIndex: "version", key: "version" },
    { title: "Image Version", dataIndex: "aiops_image_version", key: "aiops_image_version" },
  ];

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const { rootState, state, dispatch, tenantName } = useResourceContext();
  const { tableProps } = useTable({
    resource: 'addon'
  });

  useEffect(() => {
    if (
      tableProps.dataSource &&
      tableProps.dataSource.length > 0 &&
      (!state.selectedResources || state.selectedResources.length === 0)
    ) {
      dispatch({ type: "SELECT_RESOURCE", payload: tableProps.dataSource[0] });
      return;
    }
    if (
      !tableProps.loading &&
      rootState.tenantMode &&
      rootState.tenantName &&
      state.selectedResources &&
      state.selectedResources.length > 0
    ) {
      if (state.selectedResources[0].tenant && state.selectedResources[0].tenant != rootState.tenantName) {
        dispatch({
          type: "SELECT_RESOURCE",
          payload: tableProps.dataSource.length > 0 ? tableProps.dataSource[0] : null,
        });
      }
    }
  }, [tableProps]);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div>
      <TopBreadcrumb />
      <List title={"AIOps add-ons"} headerButtons={AddonVersionActions} breadcrumb={false}>
        <Table
          {...tableProps}
          rowKey={(record) => `${record.version}-${record.aiops_image_version}`}
          size={windowHeight < 1024 ? "small" : "middle"}
          rowSelection={{
            hideSelectAll: true,
            type: "radio",
            selectedRowKeys: state.selectedResources ? state.selectedResources.map((r) => (r["version"] + '-' + r["aiops_image_version"])) : [],
            onSelect: (record, selected) => {
              if (selected) {
                dispatch({ type: "SELECT_RESOURCE", payload: record });
              }
            },
          }}
          columns={columns}
          onRow={(record) => ({
            onClick: () => dispatch({ type: "SELECT_RESOURCE", payload: record }),
          })}
        />
      </List>
      <Tabs items={AddonDetailTabs} />
    </div>
  );
};